<template>
  <b-container fluid class="h-100-trim-header-footer" id="tailieWidget">
    <b-row>
      <b-col md="12" id="tailie-forgot-password">
        <div id="tailie-password">
          <p class="tailieTitle">{{ $("password-confirmation-code-title") }}</p>
          <p class="tailieSubTitle">
            {{ $("password-confirmation-sub-title") }} {{ passwordResetEmail }}
          </p>
          <b-form id="tailie-code" @submit="onSubmit">
            <div id="tailieForgotTable">
              <input
                ref="code-1"
                class="tailie-input"
                v-model="form.code1"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(1, $event)"
              />
              <input
                ref="code-2"
                class="tailie-input"
                v-model="form.code2"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(2, $event)"
              />
              <input
                ref="code-3"
                class="tailie-input"
                v-model="form.code3"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(3, $event)"
              />
              <input
                ref="code-4"
                class="tailie-input"
                v-model="form.code4"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(4, $event)"
              />
              <input
                ref="code-5"
                class="tailie-input"
                v-model="form.code5"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(5, $event)"
              />
              <input
                ref="code-6"
                class="tailie-input"
                v-model="form.code6"
                type="text"
                maxlength="1"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                v-on:keyup="refocus(6, $event)"
              />
            </div>
            <b-button
              type="submit"
              variant="primary"
              class="tailie-tab tailieBluebutton tailieSendEmailPassword margin-top-15"
            >
              {{ $("next") }}
            </b-button>
          </b-form>
          <b-button
            @click="resendCode"
            variant="link"
            class="tailieBlueUnderline tailie-tab btn btn-black margin-top-15"
            >{{ $("password-confirmation-code-resend") }}
          </b-button>
          <b-button
            @click="$router.push({ name: 'login' })"
            variant="link"
            class="tailieBlueUnderline tailie-tab btn btn-black margin-top-15"
            >{{ $("password-confirmation-code-back") }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "pages-password-reset-confirmation-code",
  data() {
    return {
      form: {
        code1: "",
        code2: "",
        code3: "",
        code4: "",
        code5: "",
        code6: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      passwordResetEmail: "users/getPasswordResetEmail"
    })
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let code =
        this.form.code1 +
        this.form.code2 +
        this.form.code3 +
        this.form.code4 +
        this.form.code5 +
        this.form.code6;

      this.$store.commit("users/SET_PASSWORD_RESET_CONFIRMATION_CODE", code);
      this.$router.push({ name: "password-reset-new" });
    },
    refocus(code, evt) {
      let previousRef = "code-" + (parseInt(code) - 1);
      let nextRef = "code-" + (parseInt(code) + 1);
      if (evt.target.value.length && nextRef in this.$refs) {
        this.$refs[nextRef].focus();
      } else if (!evt.target.value.length && previousRef in this.$refs) {
        this.$refs[previousRef].focus();
      }
    },
    resendCode() {
      this.$store.commit("ui/SET_LOADING_TEXT", "Requesting password request!");
      this.$store.commit("ui/SET_LOADING", true);
      this.$store
        .dispatch("users/requestPasswordReset", this.form.email)
        .then(() => {
          this.$store.commit("ui/SET_LOADING", false);
          this.form.code1 = "";
          this.form.code2 = "";
          this.form.code3 = "";
          this.form.code4 = "";
          this.form.code5 = "";
          this.form.code6 = "";
        })
        .catch(() => this.$store.commit("ui/SET_LOADING", false));
    }
  }
};
</script>

<style scoped>
.btn-link.btn-black {
  padding: 0.375rem 0.75rem !important;
}
</style>
